<template>
  <v-container class="no-p" fluid>
    <v-app-bar app>
      <v-btn icon to="/home">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title>{{language.pending_invoices}}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>

    <div class="list-of-content" v-if="items.length > 0">
      <v-list three-line>
        <template v-for="(item, index) in items">
          <v-list-item :key="index">
            <v-list-item-content>
              <v-list-item-title class="list-of-content__title">{{"Invoice No. " + item.nofactura}}</v-list-item-title>

              <table class="list-of-content__details">
                <tr v-if="item.total_pagar !==''">
                  <th>{{language.total_to_pay}}</th>
                  <td>{{item.total_pagar}}</td>
                </tr>
                <tr v-if="item.moneda !==''">
                  <th>{{language.currency}}</th>
                  <td>{{item.moneda}}</td>
                </tr>
                <tr v-if="item.no_ncf !==''">
                  <th>No. NFC</th>
                  <td>{{item.no_ncf}}</td>
                </tr>
                <tr v-if="item.dias_credito !==''">
                  <th>{{language.credit_days}}</th>
                  <td>{{item.dias_credito}}</td>
                </tr>
                <tr v-if="item.fec_creacion !==''">
                  <th>Creation date</th>
                  <td>{{item.fec_creacion}}</td>
                </tr>
              </table>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </div>
    <!-- <v-list two-line class="list-view" v-if="items.length > 0">
      <template v-for="(item) in items">
        <v-list-tile class="list-view-item" :key="item.title" avatar ripple>
          <v-list-tile-content>
            <v-list-tile-title :class="'pack-title'">{{ item.oficina }}</v-list-tile-title>

            <table
              v-bind:class="item.longitud !=='' && item.latitud !=='' ? 'pack-list-table mb-3' : 'has-btn pack-list-table'"
            >
              <tr>
                <th colspan="2">Direccion</th>
              </tr>
              <tr>
                <td colspan="2" style="text-align: left;padding: 0px 15px 10px 16px;">
                  <v-list-tile-sub-title class="mt-3 no-hidden-text">{{ item.direccion }}</v-list-tile-sub-title>
                </td>
              </tr>
              <tr>
                <th>Email</th>
                <td>{{item.email_address}}</td>
              </tr>
              <tr v-if="item.telefono1 !==''">
                <th>Telefono</th>
                <td>{{item.telefono1}}</td>
              </tr>
              <tr v-if="item.telefono2 !==''">
                <th>Telefono</th>
                <td>{{item.telefono2}}</td>
              </tr>
              <tr v-if="item.horario !==''">
                <th>Horario</th>
                <td>{{item.horario}}</td>
              </tr>
            </table>
            <v-btn
              color="info"
              class="mb-3 mt-1"
              block
              v-if="item.longitud !=='' && item.latitud !==''"
              @click="openMap(item.longitud,item.latitud,item.oficina)"
            >Ver en el mapa</v-btn>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>-->
    <div v-else>
      <div v-if="noData">
        <img src="../assets/nodatos.jpg" class="noData" alt />
        <div class="font-weight-black text-center">
          {{language.you_have_no_data_available}}
        </div>
      </div>
      <v-progress-circular :size="90" color="blue" indeterminate v-else class="loading-center"></v-progress-circular>
    </div>
  </v-container>
</template>

<script>
// import Helpers from "../utils/helpers";
import Server from "../utils/server";
export default {
  created() {
    this.$store.watch(
      (state, getters) => getters.user,
      // (newValue, oldValue) => {
      (newValue) => {
        console.log(newValue);
        this.currentUser = newValue;
        if (newValue.pushId !== null && newValue.userName !== null) {
          if (this.currentUser != undefined) {
            console.log(this.currentUser);
            this.getPacks();
          }
        }
      }
    );
  },
  mounted() {
    if (this.currentUser != undefined) {
      this.getPacks();
    } else if (this.user.userName != null) {
      this.currentUser = this.user;
      this.getPacks();
    }
  },
  data() {
    return {
      clipped: false,
      items: [],
      currentUser: undefined,
    };
  },
  computed: {
    login: function () {
      return this.$store.getters.login;
    },
    user: function () {
      return this.$store.getters.user;
    },
    language: function () {
      return this.$store.getters.language;
    },
  },
  methods: {
    openMap(log, lat, title) {
      window.MobileApi.openLocationInMap(log, lat, title);
    },
    getPacks() {
      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);
      this.$http.post(Server.listInvoice, formData).then(
        (response) => {
          if (response.body.resultado !== "NO") {
            this.items = response.body;
          } else {
            this.items = [];
            this.noData = true;
          }
        },
        () => {
          this.error = true;
          this.msj = this.language.an_error_has_occurred_try_again_later;
        }
      );
    },
  },
  name: "App",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
